import { Value } from '@philips-internal/oswald-ui-core';
import { Injectable } from '@odinjs/odin';

let accountCreationData: Record<string, Value>;

@Injectable({})
export default class AccountCreationBlackboard {

  public get accountData(): Record<string, Value> {
    return accountCreationData;
  }
  public set accountData(val: Record<string, Value>) {
    accountCreationData = val;
  }

}